import React, { useEffect, useState } from 'react';
import { useStyles } from './Themable.hooks';

import SearchField from '../../../../components/common/SearchField/SearchField';
import PaneHeader from '../../../../components/PaneHeader/PaneHeader';
import SourceSetGrid from '../../../../components/SourceSetGrid/SourceSetGrid';
import TranslationHelper from '../../../../helpers/TranslationHelper';

import { Paper } from '@material-ui/core';
import { ISourceSetEntity } from '../../../../state/types';
import { useSelectedProductId, useSourceSet } from '../../state/index.hooks';
import { fetchProducts, selectProduct } from '../../state';
import useAsyncThunkWithSnackbar from '../../../../hooks/useAsyncThunkWithSnackbar';
import { useToolkitDispatch } from '../../../../hooks';
import { useProductsSourceSetModel } from '../../../../pages/management/selectors/index.hooks';

const ProductsGridPane = () => {
    const sourceSetModel = useProductsSourceSetModel();
    const sourceSet = useSourceSet();
    const selectedProductId = useSelectedProductId();
    const [filter, setFilter] = useState(sourceSetModel?.quickFilter || '');
    const classes = useStyles();
    const handleAsyncRequest = useAsyncThunkWithSnackbar();

    const toolkitDispatch = useToolkitDispatch();

    const handleFetchProducts = () => {
        handleAsyncRequest({
            asyncAction: fetchProducts(),
        });
    };

    useEffect(() => {
        handleFetchProducts();
    }, []);

    const handleCellInteraction = (data: ISourceSetEntity) => {
        toolkitDispatch(selectProduct(+data.id));
    };

    return (
        <Paper className={classes.pane}>
            <div className={classes.wrapper}>
                <PaneHeader
                    title={TranslationHelper.translate('Products')}
                    renderLeftCustomControls={() => (
                        <SearchField value={filter} filterChange={setFilter} />
                    )}
                />
                {sourceSet && (
                    <SourceSetGrid
                        sourceSet={sourceSet}
                        cellInteractionHandler={handleCellInteraction}
                        quickFilterValue={filter}
                        sourceSetModel={sourceSetModel}
                        selectedSourceSetElementId={selectedProductId}
                        columnWidth={500}
                        disableAutoSize
                    />
                )}
            </div>
        </Paper>
    );
};

export default ProductsGridPane;
